import { uploadData } from 'aws-amplify/storage';
import { Amplify } from 'aws-amplify';
import { awsConfig } from '../config/aws-export';

async function S3UploadHookFileTransfer(file, key) {
    Amplify.configure(awsConfig);

    try {
        const result = await uploadData({
            path: `transfer-files/${key}`,
            data: file,
            options: {
                contentType: file.type,
            },
        }).result;
        return result.path; // Return the key of the uploaded file
    } catch (error) {
        console.log("error", error);
        throw new Error('S3 upload failed');
    }
}

export default S3UploadHookFileTransfer;
